import React from 'react';
import cx from 'classnames';

import Form from './Form';

import styles from './styles.css';

const Newsletter = ({ copy, hasLightBg, headline, noSpacing }) => {
  const containerClasses = cx({
    [styles.container]: true,
    [styles.hasLightBg]: hasLightBg,
    [styles.noSpacing]: noSpacing,
  });

  const gridClasses = cx({
    [styles.grid]: true,
    [styles.gridNoSpacing]: noSpacing,
  });

  return (
    <div className={containerClasses}>
      <div className={gridClasses}>
        {!!headline && <h1 className={styles.headline}>{headline}</h1>}
        <div
          className={styles.copy}
          dangerouslySetInnerHTML={{ __html: copy }}
        />
        <Form hasDarkButton={!!hasLightBg} />
      </div>
    </div>
  );
};

export default Newsletter;



// WEBPACK FOOTER //
// ./src/components/Newsletter/index.js